/**
 * @generated SignedSource<<0f18bd7ba76886e131f74970e7aa503f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InsightsTabNotificationsTable_brand$data = {
  readonly currencyCode: string;
  readonly displayName: string;
  readonly id: string;
  readonly notifications: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly attributedNotification: {
          readonly attributedOrders: number | null;
          readonly attributedSales: number;
          readonly pushNotificationDeliveries: number;
          readonly pushNotificationTaps: number;
        } | null;
        readonly audiences: ReadonlyArray<{
          readonly audienceName: string;
        }>;
        readonly body: string;
        readonly id: string;
        readonly thumbnailUrl: string | null;
        readonly timestamp: any;
        readonly title: string;
        readonly uuid: any;
      };
    }>;
    readonly totalCount: number | null;
  };
  readonly " $fragmentType": "InsightsTabNotificationsTable_brand";
};
export type InsightsTabNotificationsTable_brand$key = {
  readonly " $data"?: InsightsTabNotificationsTable_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InsightsTabNotificationsTable_brand">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "notifications"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./InsightsTabNotificationsTablePaginationQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "InsightsTabNotificationsTable_brand",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencyCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": "notifications",
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "isPushed": true
          }
        }
      ],
      "concreteType": "GraphQLNotificationConnection",
      "kind": "LinkedField",
      "name": "__InsightsTabNotificationsTable_notifications_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLNotificationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLNotification",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GraphQLCDPAudience",
                  "kind": "LinkedField",
                  "name": "audiences",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "audienceName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "body",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "thumbnailUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "timestamp",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GraphQLAttributedNotificationMetric",
                  "kind": "LinkedField",
                  "name": "attributedNotification",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "attributedSales",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "attributedOrders",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "pushNotificationDeliveries",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "pushNotificationTaps",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__InsightsTabNotificationsTable_notifications_connection(filters:{\"isPushed\":true})"
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "c13e72f748aacb7f428b39d416ec88d9";

export default node;
